import type {AutocompleteProps} from '@mui/material/Autocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import type {TextFieldProps} from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import {ReactNode} from 'react';
import {Controller, useFormContext} from 'react-hook-form';

// ----------------------------------------------------------------------

export type AutocompleteBaseProps = Omit<AutocompleteProps<any, boolean, boolean, boolean>, 'renderInput'>;

export type RHFAutocompleteProps = AutocompleteBaseProps & {
  name: string;
  label?: string;
  placeholder?: string;
  helperText?: ReactNode;
  slotProps?: AutocompleteBaseProps['slotProps'] & {
    textfield?: TextFieldProps;
  };
};

export const RHFAutocomplete = ({name, label, slotProps, helperText, placeholder, ...other}: RHFAutocompleteProps) => {
  const {control, setValue} = useFormContext();

  const {textfield, ...otherSlotProps} = slotProps ?? {};

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <Autocomplete
          {...field}
          id={`rhf-autocomplete-${name}`}
          onChange={(_event, newValue) => setValue(name, newValue, {shouldValidate: true})}
          renderInput={(params) => (
            <TextField
              {...params}
              {...textfield}
              label={label}
              placeholder={placeholder}
              error={!!error}
              helperText={error?.message ?? helperText}
              slotProps={{
                ...textfield?.slotProps,
                htmlInput: {
                  ...params.inputProps,
                  autoComplete: 'new-password',
                  ...textfield?.slotProps?.htmlInput,
                },
              }}
            />
          )}
          {...other}
          {...otherSlotProps}
        />
      )}
    />
  );
};
